var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCargoTruck(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    enableBackground: "new 0 0 50 50",
    height: 512,
    viewBox: "0 0 50 50",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m18.9281 46.1879 2.5436 1.4263.7328.0717 1.0149-.749-1.6664-2.2645-1.0943-.4069z",
    fill: "#282828"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m39.2385 34.6365 2.2454 1.3035 1.1261-.0297.9198-.5248-1.6664-2.2645-1.0943-.4069z",
    fill: "#282828"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    enableBackground: "new"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m48.86 26.4184-15.0512-8.7468c-.0841-.0489-.2006-.0421-.3289.0319l15.0512 8.7468c.1283-.074.2448-.0808.3289-.0319z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    enableBackground: "new"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m48.86 26.4184-15.0512-8.7468c-.0119-.0069-.0244-.0127-.0375-.0174l15.0512 8.7468c.0131.0047.0256.0105.0375.0174",
    fill: "#2b2f35"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m48.8224 26.4011-15.0512-8.7468c-.0104-.0037-.0212-.0067-.0324-.0089l15.0512 8.7468c.0112.0022.022.0052.0324.0089",
    fill: "#2d3137"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m48.7901 26.3922-15.0512-8.7468c-.0087-.0017-.0176-.003-.0267-.0039l15.0512 8.7468c.009.0008.018.0021.0267.0039",
    fill: "#2e3339"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m48.7634 26.3883-15.0512-8.7468c-.0079-.0007-.0159-.0011-.024-.0011l15.0512 8.7468c.0081 0 .0161.0004.024.0011",
    fill: "#30353b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m48.7394 26.3871-15.0512-8.7468c-.0072 0-.0144.0002-.0218.0007l15.0512 8.7468c.0073-.0004.0146-.0007.0218-.0007",
    fill: "#33383d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m48.7176 26.3879-15.0512-8.7469c-.0068.0005-.0136.0012-.0206.0021l15.0512 8.7469c.007-.001.0138-.0017.0206-.0021",
    fill: "#33393f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m48.697 26.39-15.0512-8.7468c-.0067.0009-.0134.002-.0202.0033l15.0512 8.7468c.0068-.0013.0136-.0024.0202-.0033",
    fill: "#353a41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m48.6768 26.3933-15.0512-8.7468c-.0063.0012-.0126.0026-.0189.0042l15.0512 8.7468c.0063-.0016.0126-.003.0189-.0042",
    fill: "#373c43"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m48.6579 26.3975-15.0512-8.7468c-.0063.0016-.0127.0033-.0191.0053l15.0512 8.7468c.0064-.002.0128-.0037.0191-.0053",
    fill: "#393e45"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m48.6388 26.4028-15.0512-8.7468c-.0061.0018-.0123.0039-.0185.006l15.0512 8.7468c.0062-.0022.0124-.0042.0185-.006",
    fill: "#3a4047"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m48.6203 26.4088-15.0512-8.7468c-.0062.0022-.0124.0045-.0186.007l15.0512 8.7468c.0062-.0025.0125-.0048.0186-.007",
    fill: "#3c4249"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m48.6017 26.4158-15.0512-8.7468c-.0061.0024-.0123.0051-.0184.0078l15.0512 8.7468c.0062-.0027.0123-.0053.0184-.0078",
    fill: "#3e434b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m48.5833 26.4236-15.0513-8.7468c-.0062.0028-.0124.0057-.0187.0088l15.0512 8.7468c.0064-.0031.0126-.006.0188-.0088",
    fill: "#40454e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m48.5646 26.4324-15.0512-8.7468c-.0063.0031-.0125.0063-.0189.0098l15.0512 8.7468c.0064-.0034.0127-.0067.0189-.0098",
    fill: "#424750"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m48.5458 26.4422-15.0513-8.7468-.0146.0081 15.0512 8.7469z",
    fill: "#424952"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m48.5311 26.4504-15.0512-8.7469-.1126.0651 15.0512 8.7468z",
    fill: "#484e58"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m48.4185 26.5154-15.0512-8.7468-22.5047 12.8211 15.0512 8.7468z",
    fill: "#484e58"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m24.9686 32.6838-15.0512-8.7468c.0002.082-.0589.1843-.1359.2288l15.0512 8.7468c.0771-.0445.1362-.1467.1359-.2288z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m1 36.8158v1.7455c.0093.1487.0557.2507.1392.3065l15.051 8.7464c-.0836-.0553-.13-.1578-.13-.3065l-.0093-1.7455c0-.2874.2043-.6497.4642-.7984l9.3964-5.4318-15.0509-8.7464-9.3964 5.4318c-.26.1483-.4642.5015-.4642.7984z",
    fill: "#686868"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m16.5118 44.7648c-.2549.1472-.4617.5053-.4609.7984l.0049 1.7436c.0008.2997.209.4187.4639.2715l32.0194-18.3144c.2549-.1472.4617-.5057.4609-.8054l-.0049-1.7436c-.0008-.2931-.209-.4116-.4639-.2645l-.1126.065-22.5048 12.8211z",
    fill: "#4f4d4d"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m43.2062 31.6568c.0186-.0186.0279-.0281.0464-.0467v1.6992c-.0093 0-.0278 0-.0371-.0091-.0093 0-.0093 0-.0186 0h-.0278c-.0093 0-.0093 0-.0186 0-.0093-.0095-.0186-.0095-.0371-.0095l-.0093-.0091c-.0093 0-.0186 0-.0279-.0095-.0092 0-.0092 0-.0092 0-.0186-.0091-.0279-.0186-.0372-.0186l-.0093-.0091c-.0093 0-.0185-.0095-.0278-.0186 0 0-.0093 0-.0093-.0091-.0093 0-.0186-.0095-.0279-.019-.0185-.0091-.0278-.0277-.0371-.0372 0 0 0 0 0-.0091-.0093-.0091-.0186-.0186-.0278-.0277 0 0 0 0 0-.0095-.0093-.0091-.0186-.0186-.0279-.0372v-.0091c-.0093-.0095-.0093-.0186-.0186-.0372 0 0 0 0 0-.0095-.0092-.0091-.0185-.0277-.0185-.0462 0 0 0 0-.0093-.0095 0-.0091 0-.0277-.0093-.0372 0-.0091 0-.0091 0-.0181-.0093-.0095-.0093-.0281-.0093-.0467 0-.0091 0-.0091 0-.0091 0-.0186-.0093-.0372-.0093-.0558v-.1487c0-.0186 0-.0372.0093-.0558 0-.0091 0-.0091 0-.0091 0-.0281 0-.0467.0093-.0648 0-.0095 0-.019 0-.019 0-.0181.0093-.0372.0093-.0553 0 0 0-.0095.0093-.0186 0-.0186.0093-.0372.0093-.0558 0-.0095.0092-.0186.0092-.0186 0-.0186.0093-.0372.0093-.0558.0093 0 .0093-.0091.0093-.0186.0093-.0186.0186-.0372.0186-.0558.0093-.0091.0093-.0091.0093-.0186.0092-.0186.0092-.0372.0185-.0462.0093-.0095.0093-.0186.0093-.0281.0093-.0186.0186-.0372.0279-.0558v-.0091c.0092-.0186.0185-.0372.0371-.0558 0-.0095 0-.0186.0093-.0186.0093-.0186.0185-.0372.0278-.0558v-.0091c.0186-.0186.0279-.0372.0372-.0558.0093-.0095.0093-.0186.0093-.0186.0092-.0186.0278-.0372.0371-.0467 0-.0091 0-.0091.0093-.0181.0093-.019.0185-.0372.0371-.0558l.0093-.0095c.0093-.0186.0278-.0277.0371-.0462 0-.009.0093-.009.0093-.0181z",
    fill: "#929393"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m24.9538 27.4456-15.0512-8.7469.0148 5.2383 15.0512 8.7468z",
    fill: "#b94234"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m24.9132 27.3586-15.0512-8.7468c.0251.0146.0405.0455.0406.0869l15.0512 8.7468c-.0001-.0413-.0155-.0722-.0406-.0869z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    enableBackground: "new"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m24.9132 27.3586-15.0512-8.7468c.0097.0056.0179.0137.0244.0238l15.0512 8.7468c-.0065-.0101-.0147-.0181-.0244-.0238",
    fill: "#7e2c23"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m24.9376 27.3824-15.0513-8.7468.0053.0096 15.0513 8.7468z",
    fill: "#812e24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m24.9429 27.392-15.0513-8.7468.0034.0079 15.0512 8.7468z",
    fill: "#853026"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m24.9462 27.3999-15.0512-8.7468.0023.0072 15.0513 8.7468z",
    fill: "#8b3227"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m24.9486 27.4071-15.0513-8.7468.0018.0069 15.0513 8.7468z",
    fill: "#903329"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m24.9504 27.414-15.0513-8.7468.0014.0065 15.0512 8.7468z",
    fill: "#95352b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m24.9517 27.4205-15.0512-8.7468.0009.0063 15.0512 8.7468z",
    fill: "#9a362b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m24.9526 27.4268-15.0512-8.7468.0006.0063 15.0513 8.7468z",
    fill: "#9e382c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m24.9533 27.4331-15.0513-8.7468.0004.006 15.0512 8.7468z",
    fill: "#a33a2e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m24.9536 27.4391-15.0512-8.7468.0002.0061 15.0512 8.7468z",
    fill: "#a83b2f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m24.9538 27.4452-15.0512-8.7468v.0002l15.0512 8.747v-.0003",
    fill: "#ac3c30"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m24.9132 27.3586-15.0513-8.7468c-.0245-.0142-.0582-.013-.0962.0089l15.0512 8.7468c.0381-.0219.0718-.0231.0963-.0089z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    enableBackground: "new"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m24.9132 27.3586-15.0513-8.7468-.0112-.0052 15.0512 8.7468z",
    fill: "#24282d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m24.9019 27.3534-15.0512-8.7468-.0097-.0027 15.0512 8.7469z",
    fill: "#26292e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m24.8922 27.3508-15.0512-8.7469-.0079-.0011 15.0513 8.7468z",
    fill: "#272b30"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m24.8844 27.3496-15.0513-8.7468-.0069-.0003 15.0512 8.7468z",
    fill: "#292c32"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m24.8774 27.3493-15.0512-8.7468-.0066.0002 15.0513 8.7468z",
    fill: "#2a2e34"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m24.8709 27.3495-15.0513-8.7468-.0058.0006 15.0512 8.7468z",
    fill: "#2b2f35"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m24.865 27.3501-15.0512-8.7468-.0059.0009 15.0513 8.7469z",
    fill: "#2d3137"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m24.8592 27.3511-15.0513-8.7469-.0055.0013 15.0512 8.7468z",
    fill: "#2e3239"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m24.8536 27.3523-15.0512-8.7468-.0055.0015 15.0512 8.7468z",
    fill: "#30343a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m24.8481 27.3538-15.0512-8.7468-.0054.0017 15.0513 8.7469z",
    fill: "#31353c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m24.8428 27.3556-15.0513-8.7469-.0053.0021 15.0512 8.7468z",
    fill: "#32373e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m24.8374 27.3576-15.0512-8.7468-.0053.0022 15.0512 8.7468z",
    fill: "#343940"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m24.8321 27.3598-15.0512-8.7468-.0054.0026 15.0512 8.7468z",
    fill: "#353a41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m24.8267 27.3624-15.0512-8.7468-.0055.0028 15.0512 8.7468z",
    fill: "#383c44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m24.8212 27.3652-15.0512-8.7468-.0042.0024 15.0512 8.7468z",
    fill: "#383d46"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m10.8235 15.8039.0372 14.7817 15.051 8.7466-.0372-14.7817c0-.4639.2573-1.0049.616-1.3691l-15.0508-8.7466c-.3589.3637-.6162.9052-.6162 1.3691z",
    fill: "#d7d7d7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m33.0485 2.381c-.1764-.102-.4085-.0927-.6777.0655l-20.6095 11.7236c-.1143.0674-.2206.1621-.3217.2646l15.0508 8.7466c.1011-.1025.2075-.1973.3218-.2646l20.6095-11.7241c.2692-.1577.5107-.167.6778-.0645z",
    fill: "#e8e8e8"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m26.8114 22.9208c-.5217.3012-.9412 1.0346-.9395 1.6341l.0419 14.7816 22.5047-12.8211-.0419-14.7816c-.0017-.5994-.424-.8468-.9516-.5422z",
    fill: "#bfbfbf"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m24.8327 32.9126-15.0512-8.7468-6.4142 3.7032 15.0512 8.7468z",
    fill: "#ce493a"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m3.3673 27.869c-.1122.0648-.2092.069-.2792.0284l15.0512 8.7468c.0699.0406.167.0364.2792-.0284-4.5154-2.624-10.5359-6.1227-15.0512-8.7468z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    enableBackground: "new"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m18.4185 36.6158-15.0512-8.7468-.013.0073 15.0513 8.7468z",
    fill: "#c04335"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m18.4056 36.6231-15.0513-8.7468c-.0056.003-.0111.0059-.0166.0086l15.0512 8.7468c.0056-.0027.0111-.0056.0167-.0086",
    fill: "#bb4234"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m18.389 36.6317-15.0513-8.7468c-.0055.0027-.0109.0053-.0163.0077l15.0512 8.7468c.0054-.0024.0109-.005.0164-.0077",
    fill: "#b64033"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m18.3726 36.6394-15.0512-8.7468c-.0054.0024-.0108.0047-.0161.0068l15.0512 8.7468c.0053-.0021.0107-.0044.0161-.0068",
    fill: "#b13e32"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m18.3565 36.6462-15.0512-8.7468c-.0053.0021-.0106.0041-.0158.006l15.0512 8.7468c.0052-.0019.0105-.0039.0158-.006",
    fill: "#ac3c30"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m18.3407 36.6522-15.0512-8.7469c-.0054.0019-.0107.0036-.016.0052l15.0512 8.7468c.0053-.0015.0106-.0032.016-.0051",
    fill: "#a83b2f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m18.3247 36.6574-15.0512-8.7468c-.0054.0016-.0108.0031-.0161.0044l15.0512 8.7468c.0053-.0013.0107-.0028.0161-.0044",
    fill: "#a33a2e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m18.3086 36.6618-15.0513-8.7468c-.0053.0013-.0106.0025-.0158.0035l15.0512 8.7468c.0053-.001.0105-.0021.0159-.0035",
    fill: "#9e382c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m18.2927 36.6653-15.0512-8.7468c-.0058.0011-.0116.0021-.0173.0028l15.0512 8.7468c.0057-.0007.0115-.0016.0173-.0028",
    fill: "#9a362b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m18.2754 36.6682-15.0512-8.7468c-.0057.0008-.0113.0013-.0169.0017l15.0512 8.7468c.0056-.0004.0113-.001.0169-.0017",
    fill: "#95352b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m18.2586 36.6699-15.0512-8.7468c-.0064.0004-.0127.0006-.0189.0006l15.0512 8.7468c.0062 0 .0125-.0002.0189-.0006",
    fill: "#903329"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m18.2397 36.6705-15.0512-8.7468c-.0064 0-.0127-.0003-.0189-.0009l15.0512 8.7468c.0062.0005.0125.0009.0189.0009",
    fill: "#8b3227"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m18.2208 36.6696-15.0512-8.7468c-.0079-.0007-.0156-.0018-.0232-.0034l15.0512 8.7468c.0075.0016.0153.0027.0232.0034",
    fill: "#853026"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m18.1976 36.6662-15.0512-8.7468c-.0095-.0019-.0187-.0045-.0276-.0077l15.0512 8.7468c.0089.0032.0181.0058.0276.0077",
    fill: "#812e24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m18.17 36.6585-15.0512-8.7468c-.0108-.0039-.021-.0087-.0308-.0143l15.0512 8.7468c.0098.0056.0201.0104.0308.0143",
    fill: "#7e2c23"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m3.088 27.8974 15.0512 8.7468c-.1149-.0668-.1567-.2545-.0725-.4938l-15.0511-8.7469c-.0842.2394-.0424.4271.0724.4939z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    enableBackground: "new"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m18.0668 36.1503-15.0512-8.7468-.0047.0136 15.0513 8.7468z",
    fill: "#424751"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m18.0622 36.1639-15.0513-8.7468c-.0025.0075-.0049.0148-.0071.0222l15.0512 8.7468c.0023-.0073.0047-.0147.0072-.0222",
    fill: "#404650"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m18.055 36.1861-15.0512-8.7468c-.0022.0073-.0044.0146-.0064.0219l15.0512 8.7468c.0021-.0072.0042-.0145.0064-.0219",
    fill: "#40444d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m18.0487 36.208-15.0513-8.7468c-.002.0074-.004.0147-.0058.0219l15.0512 8.7468c.0019-.0072.0038-.0145.0059-.0219",
    fill: "#3e434c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m18.0429 36.2299-15.0512-8.7468c-.0018.0073-.0035.0144-.005.0216l15.0512 8.7468c.0015-.0071.0032-.0143.005-.0216",
    fill: "#3d414a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m18.0379 36.2515-15.0513-8.7468c-.0015.0071-.003.0141-.0043.021l15.0512 8.7468c.0014-.0069.0028-.0139.0044-.021",
    fill: "#3b4048"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m18.0336 36.2725-15.0512-8.7468c-.0013.0069-.0025.0137-.0035.0204l15.0512 8.7468c.001-.0067.0022-.0135.0035-.0204",
    fill: "#393e47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m18.0301 36.293-15.0513-8.7469c-.0011.0067-.002.0134-.0029.02l15.0512 8.7468c.0009-.0065.0019-.0132.003-.0199",
    fill: "#383d46"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m18.0272 36.313-15.0512-8.7468c-.0008.0066-.0016.0131-.0022.0195l15.0512 8.7468c.0007-.0064.0014-.0129.0022-.0195",
    fill: "#383c44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m18.025 36.3325-15.0512-8.7468c-.0006.0064-.0011.0128-.0015.0191l15.0512 8.7468c.0004-.0063.0009-.0126.0015-.0191",
    fill: "#353a41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m18.0235 36.3516-15.0512-8.7468c-.0004.0064-.0007.0127-.0009.0189l15.0512 8.7468c.0002-.0062.0005-.0125.0009-.0189",
    fill: "#343940"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m18.0226 36.3705-15.0512-8.7468c-.0002.0063-.0003.0126-.0002.0188l15.0512 8.7468c0-.0062 0-.0124.0002-.0188",
    fill: "#32373e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m18.0224 36.3893-15.0512-8.7468c0 .0062.0002.0123.0004.0183l15.0512 8.7468c-.0002-.006-.0004-.0121-.0004-.0183",
    fill: "#31353c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m18.0228 36.4077-15.0512-8.7469c.0003.0064.0007.0128.0012.0191l15.0512 8.7468c-.0005-.0062-.0009-.0126-.0012-.019",
    fill: "#30343a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m18.024 36.4267-15.0512-8.7468c.0005.0063.0012.0125.0019.0186l15.0512 8.7468c-.0007-.0061-.0014-.0123-.0019-.0186",
    fill: "#2e3239"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m18.026 36.4453-15.0513-8.7468c.0008.0066.0018.013.0029.0193l15.0512 8.7468c-.001-.0063-.002-.0127-.0028-.0193",
    fill: "#2d3137"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m18.0289 36.4646-15.0513-8.7468c.0012.0066.0025.0132.0039.0195l15.0512 8.7468c-.0014-.0063-.0027-.0128-.0038-.0195",
    fill: "#2b2f35"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m18.0328 36.4842-15.0512-8.7469c.0016.007.0034.0139.0054.0205l15.0512 8.7468c-.002-.0066-.0038-.0134-.0054-.0204",
    fill: "#2a2e34"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m18.0381 36.5047-15.0512-8.7468c.0021.0072.0045.0143.007.0211l15.0512 8.7468c-.0025-.0068-.0048-.0139-.007-.0211",
    fill: "#292c32"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m18.0452 36.5258-15.0513-8.7469c.0031.0084.0065.0164.0102.0242l15.0512 8.7468c-.0036-.0077-.007-.0158-.0101-.0241",
    fill: "#272b30"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m18.0554 36.5499-15.0512-8.7468c.0047.0098.0099.019.0155.0277l15.0512 8.7468c-.0056-.0087-.0108-.0179-.0155-.0277",
    fill: "#26292e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m18.0709 36.5776-15.0513-8.7468c.0183.0283.0413.0508.0684.0665l15.0512 8.7468c-.027-.0157-.0501-.0381-.0683-.0665",
    fill: "#24282d"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m1.6035 28.8774.0186 7.0472 15.051 8.7464-.0186-7.0472c0-.1487.0278-.2974.0836-.4642l-15.051-8.7464c-.0557.1668-.0836.3155-.0836.4642z",
    fill: "#ef5a5a"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m24.817 27.3676-15.0512-8.7468-4.2979 2.4813 15.0512 8.7469z",
    fill: "#3d414a"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m20.1641 30.2997-15.0512-8.7468-2.0973 5.8506 15.0512 8.7468z",
    fill: "#424851"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m20.5191 29.849-15.0512-8.7469c-.1482.0856-.2843.2596-.355.4508l15.0512 8.7468c.0707-.1911.2068-.3652.355-.4507z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    enableBackground: "new"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m20.5191 29.849-15.0512-8.7469-.0038.0023 15.0512 8.7468z",
    fill: "#383d46"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m20.5153 29.8512-15.0512-8.7468c-.0055.0032-.011.0066-.0164.01l15.0512 8.7468c.0054-.0034.0109-.0068.0164-.01",
    fill: "#393e47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m20.4989 29.8612-15.0513-8.7468c-.0056.0036-.0112.0073-.0168.0111l15.0512 8.7468c.0056-.0038.0112-.0075.0169-.0111",
    fill: "#3b4048"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m20.4821 29.8724-15.0513-8.7469c-.0057.0039-.0115.008-.0172.0122l15.0512 8.7468c.0058-.0041.0115-.0082.0173-.0121",
    fill: "#3d414a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m20.4649 29.8845-15.0512-8.7468c-.0059.0043-.0117.0088-.0175.0133l15.0512 8.7468c.0058-.0045.0116-.0089.0175-.0133",
    fill: "#3e434c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m20.4474 29.8979-15.0512-8.7468c-.006.0047-.0119.0096-.0178.0145l15.0512 8.7468c.0059-.005.0118-.0098.0178-.0145",
    fill: "#40444d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m20.4296 29.9124-15.0512-8.7468c-.006.0051-.012.0103-.018.0157l15.0512 8.7468c.006-.0054.012-.0106.018-.0157",
    fill: "#404650"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m20.4117 29.9281-15.0513-8.7469c-.006.0054-.0119.0109-.0177.0165l15.0512 8.7468c.0059-.0056.0118-.0111.0178-.0164",
    fill: "#424751"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m20.3939 29.9446-15.0512-8.7469c-.0058.0055-.0115.0112-.0172.017l15.0512 8.7468c.0057-.0057.0114-.0114.0172-.0169",
    fill: "#434953"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m20.3768 29.9615-15.0513-8.7468c-.0055.0057-.0111.0115-.0165.0173l15.0512 8.7468c.0055-.0058.011-.0116.0166-.0173",
    fill: "#454a55"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m20.3602 29.9789-15.0512-8.7469c-.0054.0058-.0107.0117-.0159.0177l15.0512 8.7468c.0053-.006.0106-.0119.0159-.0176",
    fill: "#464c56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m20.3443 29.9965-15.0512-8.7468c-.0052.006-.0104.012-.0155.0182l15.0512 8.7468c.0051-.0062.0103-.0122.0155-.0182",
    fill: "#5c626b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m20.3288 30.0147-15.0513-8.7469c-.0053.0063-.0105.0128-.0156.0193l15.0512 8.7468c.0052-.0065.0104-.0129.0157-.0192",
    fill: "#656a73"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m20.3132 30.034-15.0513-8.7469c-.0058.0073-.0115.0148-.0171.0224l15.0512 8.7468c.0057-.0075.0114-.015.0172-.0223",
    fill: "#6d7279"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m20.2961 30.0564-15.0513-8.7469c-.0084.0113-.0166.0229-.0246.0348l15.0512 8.7468c.008-.0118.0163-.0234.0247-.0347",
    fill: "#72777f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m20.2715 30.0911-15.0513-8.7468c-.0117.0173-.0229.0351-.0336.0533l15.0512 8.7468c.0108-.0182.022-.036.0337-.0533",
    fill: "#787c83"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m20.2379 30.1444-15.0512-8.7468c-.0069.0118-.0136.0238-.0201.0359l15.0512 8.7468c.0065-.0121.0132-.0241.0201-.0359",
    fill: "#72777f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m20.2178 30.1803-15.0512-8.7468c-.0043.008-.0084.016-.0124.0241l15.0512 8.7468c.004-.0081.0082-.0161.0124-.0241",
    fill: "#6d7279"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m20.2054 30.2044-15.0512-8.7468c-.0035.007-.0069.0141-.0102.0212l15.0512 8.7468c.0033-.0071.0067-.0141.0102-.0212",
    fill: "#656a73"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m20.1951 30.2256-15.0512-8.7468c-.0031.0066-.0061.0133-.0091.02l15.0512 8.7468c.003-.0067.006-.0134.0091-.02",
    fill: "#5c626b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m20.1861 30.2456-15.0513-8.7468c-.0029.0065-.0057.013-.0084.0196l15.0512 8.7468c.0028-.0066.0056-.0131.0085-.0196",
    fill: "#464c56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m20.1777 30.2652-15.0513-8.7468c-.0028.0066-.0054.0133-.008.0199l15.0512 8.7468c.0026-.0067.0053-.0133.0081-.0199",
    fill: "#454a55"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m20.1696 30.2851-15.0512-8.7468-.0055.0146 15.0512 8.7468z",
    fill: "#434953"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m19.3321 30.0431c.1296-.3547.384-.6789.6567-.8363l5.8867-3.3987.0384 13.5284-9.242 5.3359-.02-7.0503c-.0004-.143.0288-.2965.0878-.4601zm-.9136 6.5727 6.4142-3.7033c.0771-.0445.1362-.1467.1359-.2288l-.0149-5.2383c-.0002-.0817-.0597-.1225-.1368-.078l-4.2979 2.4814c-.1482.0856-.2843.2596-.355.4508l-2.0973 5.8506c-.1354.3852.0554.6368.3518.4656",
    fill: "#dd454d"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m20.1641 30.2996c.0707-.1909.2068-.365.355-.4506l4.0451-2.3353.0142 4.9839c.0002.0821-.0589.1845-.136.229l-6.4133 3.7027c-.0078-.0802.0002-.1723.0377-.2788z",
    fill: "#39414d"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m4.2776 21.3007 15.051 8.7464c.13-.3618.39-.6869.6593-.8451l5.8866-3.398-15.051-8.7464-5.8866 3.398c-.2693.1578-.5293.4828-.6593.8451z",
    fill: "#ef5a5a"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m19.3321 30.0431-15.0513-8.7468-2.5924 7.1189 15.0512 8.7468z",
    fill: "#bc2b3b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m5.3568 22.9954 12.8377 7.4597-1.7197 4.7205-12.8377-7.4598z",
    fill: "#39414d"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m3.6371 27.7158 12.8377 7.4598-.228.6261-13.4206-7.7989z",
    fill: "#ef5a5a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m4.7739 22.6563.5829.3391-1.7197 4.7204-.8109.287z",
    fill: "#dd454d"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m25.2381 42.6861c.0035 1.2329-.8651 2.7305-1.9322 3.3466-1.073.6195-1.9413.1247-1.9448-1.1082-.0035-1.2262.8592-2.7275 1.9322-3.3469 1.067-.6161 1.9413-.1177 1.9448 1.1085zm-1.9359 2.059c.1204-.0695.2347-.1658.3377-.2793.2823-.3118.4788-.7536.4778-1.1328-.0011-.3795-.1995-.5933-.4826-.5783-.1033.0052-.2177.0409-.3381.1105-.4505.2601-.8169.8947-.8154 1.4125.0013.5173.3701.7275.8206.4674",
    fill: "#686868"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m24.1195 43.2691v.1297s0 .0095-.0093.019v.0553.0095c0 .0186-.0092.0372-.0092.0648v.0095c-.0093.0277-.0093.0462-.0186.0648v.0091c-.0093.019-.0093.0467-.0186.0653v.0091c-.0093.0281-.0093.0467-.0186.0653 0 0 0 .0091-.0092.0091 0 .0186-.0093.0462-.0186.0653 0 .0091 0 .0091-.0093.0091 0 .0281-.0093.0462-.0186.0648 0 0 0 .0095-.0092.0095-.0093.0186-.0186.0462-.0279.0744-.0093.0186-.0278.0372-.0371.0648v.0095c-.0279.0372-.0557.0834-.0836.1297v.0095c-.0278.0372-.0557.0834-.0835.1206-.0093.0095-.0093.0095-.0093.0095-.0279.0367-.065.0739-.0929.1111 0 .0095 0 .0095-.0092.0095v.0091l-.0279.0281c-.0093 0-.0093.0091-.0186.0091 0 .0091-.0093.0186-.0185.0281-.0093 0-.0093.0091-.0186.0091l-.065.0648c-.0093 0-.0093.0095-.0186.0095-.0092.0091-.0185.0186-.0278.0186 0 .0091-.0093.0091-.0093.0186-.0093 0-.0186.0091-.0278.0186-.0093 0-.0093.0091-.0186.0091-.0093.0095-.0186.0095-.0279.0186l-.0093.0095c-.0185.0091-.0278.0186-.0464.0277-.455.2602-.8171.0462-.8171-.4642-.0092-.52.3621-1.1516.8078-1.4113.0186-.0091.0372-.0186.0465-.0277.0092 0 .0092-.0095.0185-.0095s.0186-.0091.0279-.0091c0-.0095.0093-.0095.0093-.0095.0093 0 .0185-.0091.0278-.0091s.0093-.0095.0186-.0095.0186-.0091.0278-.0091h.0093c.0093-.0095.0186-.0095.0372-.0095.0185-.0091.0278-.0091.0371-.0091.0278-.0095.0557-.0095.0836-.0095.0649-.0091.1299 0 .1949.0281.0279.0091.0557.0277.0836.0462.0093.0095.0185.0186.0371.0281.0093.0091.0186.0186.0279.0367.0092.0095.0185.019.0278.0372h.0093c.0093.019.0093.0281.0186.0467h.0092c0 .0186.0093.0277.0186.0372v.0091c.0093.0186.0093.0372.0186.0558s.0093.0281.0093.0462c0 .0095.0093.0095.0093.0095 0 .0186 0 .0372.0092.0558v.0648z",
    fill: "#888"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m26.3111 42.0666c.0054 1.914-1.3359 4.2439-3.0017 5.2056-1.6658.9618-3.0218.1892-3.0273-1.7248-.0054-1.9073 1.3418-4.241 3.0076-5.2027 1.6658-.9618 3.016-.1854 3.0214 1.7219zm-3.0052 3.9661c1.0671-.6161 1.9357-2.1137 1.9322-3.3466-.0035-1.2262-.8778-1.7246-1.9448-1.1086-1.073.6195-1.9357 2.1207-1.9322 3.3469.0034 1.233.8718 1.7278 1.9448 1.1083",
    fill: "#3d3d3d"
  })), /*#__PURE__*/React.createElement("g", {
    enableBackground: "new"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m46.6164 30.5153c.0054 1.914-1.3418 4.2473-3.0017 5.2056-1.6658.9617-3.0218.1892-3.0272-1.7248-.0054-1.9073 1.3418-4.241 3.0076-5.2027 1.6599-.9584 3.0159-.1855 3.0213 1.7219zm-3.0052 3.9661c1.0671-.6161 1.9298-2.1103 1.9263-3.3432-.0035-1.2262-.8718-1.7281-1.9389-1.112-1.073.6195-1.9356 2.1207-1.9322 3.3469.0035 1.2329.8718 1.7277 1.9448 1.1083",
    fill: "#3d3d3d"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m45.5367 31.1368c0 1.235-.8542 2.7297-1.922 3.3427-1.077.622-1.9405.1301-1.9498-1.1049 0-1.2259.8635-2.7302 1.9312-3.3522 1.0678-.6125 1.9406-.1115 1.9406 1.1144z",
    fill: "#686868"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m24.5784 32.4975-.0142-4.9839.2528-.146c.0771-.0444.1366-.0036.1368.078l.0148 5.2382c.0001.0431-.0175.0907-.0442.1337l-.3752-.224c.0144-.0321.0292-.0652.0292-.096z",
    fill: "#bc2b3b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m24.4424 32.7265c.0482-.0277.0827-.0789.1068-.1328l.3752.224c-.024.0385-.0552.0739-.0917.0948l-6.4143 3.7036c-.2144.1238-.369.0222-.3894-.1868z",
    fill: "#ef5a5a"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m44.418 31.7217v.1297s0 .0095-.0093.019v.0553.0095c0 .0186-.0092.0372-.0092.0648v.0095c-.0093.0277-.0093.0462-.0186.0648v.0091c-.0093.019-.0093.0467-.0186.0653v.0091c-.0093.0281-.0093.0467-.0186.0653 0 0 0 .0091-.0092.0091 0 .0186-.0093.0462-.0186.0653 0 .0091 0 .0091-.0093.0091 0 .0281-.0093.0462-.0186.0648 0 0 0 .0095-.0092.0095-.0093.0186-.0186.0462-.0279.0744-.0093.0186-.0278.0372-.0371.0648v.0095c-.0279.0372-.0557.0834-.0836.1297v.0095c-.0278.0372-.0557.0834-.0835.1206-.0093.0095-.0093.0095-.0093.0095-.0279.0367-.065.0739-.0929.1111 0 .0095 0 .0095-.0092.0095v.0091l-.0279.0281c-.0093 0-.0093.0091-.0186.0091 0 .0091-.0093.0186-.0185.0281-.0093 0-.0093.0091-.0186.0091l-.065.0648c-.0093 0-.0093.0095-.0186.0095-.0092.0091-.0185.0186-.0278.0186 0 .0091-.0093.0091-.0093.0186-.0093 0-.0186.0091-.0278.0186-.0093 0-.0093.0091-.0186.0091-.0093.0095-.0186.0095-.0279.0186l-.0093.0095c-.0185.0091-.0278.0186-.0464.0277-.455.2602-.8171.0462-.8171-.4642-.0092-.52.3621-1.1516.8078-1.4113.0186-.0091.0372-.0186.0465-.0277.0092 0 .0092-.0095.0185-.0095s.0186-.0091.0279-.0091c0-.0095.0093-.0095.0093-.0095.0093 0 .0185-.0091.0278-.0091s.0093-.0095.0186-.0095.0186-.0091.0278-.0091h.0093c.0093-.0095.0186-.0095.0372-.0095.0185-.0091.0278-.0091.0371-.0091.0278-.0095.0557-.0095.0836-.0095.0649-.0091.1299 0 .195.0281.0279.0091.0557.0277.0836.0462.0093.0095.0185.0186.0371.0281.0093.0091.0186.0186.0279.0367.0092.0095.0185.019.0278.0372h.0093c.0093.019.0093.0281.0186.0467h.0092c0 .0186.0093.0277.0186.0372v.0091c.0093.0186.0093.0372.0186.0558s.0093.0281.0093.0462c0 .0095.0093.0095.0093.0095 0 .0186 0 .0372.0092.0558v.0648z",
    fill: "#888"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m3.8998 34.9999c.4268.2464.7695.84.7681 1.3304-.0014.4974-.3463.694-.7732.4476-.4268-.2464-.7695-.84-.7681-1.3375.0015-.4904.3464-.6869.7732-.4405z",
    fill: "#fee44b"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m5.1807 35.5895c.1304.0753.2368.2592.2363.4093l-.0043 1.5326c-.0004.1501-.1075.2108-.2379.1355l-2.561-1.4786c-.1304-.0753-.2368-.2592-.2364-.4093l.0043-1.5326c.0004-.1501.1075-.2108.2379-.1355zm-1.2859 1.1884c.4268.2464.7718.0499.7732-.4476.0014-.4904-.3413-1.084-.7681-1.3304-.4269-.2464-.7718-.0499-.7732.4406-.0014.4974.3413 1.091.7681 1.3374",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m14.0268 40.8654c.4268.2464.7695.84.7681 1.3304-.0014.4974-.3464.694-.7732.4476s-.7755-.8434-.7741-1.3409c.0014-.4904.3523-.6835.7792-.4371z",
    fill: "#fee44b"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m15.3076 41.455c.1304.0753.2368.2592.2364.4093l-.0043 1.5326c-.0004.1501-.1075.2108-.2379.1355l-2.561-1.4786c-.1304-.0753-.2368-.2592-.2364-.4093l.0043-1.5326c.0004-.1501.1075-.2108.2379-.1355zm-1.2859 1.1884c.4268.2464.7718.0499.7732-.4476.0014-.4904-.3413-1.084-.7681-1.3304s-.7777-.0533-.7791.4371c-.0015.4974.3472 1.0944.774 1.3409",
    fill: "#fff"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCargoTruck);
export default __webpack_public_path__ + "static/media/cargo-truck.f500098c3ca684640d14fd1902e0134e.svg";
export { ForwardRef as ReactComponent };